import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const handleBuy = () => {
    window.location.href = 'https://newdigitalguide.com/cart/42939863072830:1';
  };
  return <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 mb-10" data-id="element-157">
      <FadeIn data-id="element-158">
        <div className="bg-brand-burgundy rounded-3xl p-8 md:p-12 text-center shadow-xl relative overflow-hidden" data-id="element-159">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10 mix-blend-overlay" data-id="element-160"></div>

          <div className="relative z-10 space-y-8" data-id="element-161">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-cream leading-tight" data-id="element-162">
              No dejes que estos recuerdos desaparezcan.
            </h2>

            <div className="flex flex-col items-center gap-6" data-id="element-163">
              <button onClick={handleBuy} className="bg-brand-cream hover:bg-white text-brand-burgundy font-bold text-lg rounded-xl py-4 px-8 shadow-lg transition-all active:scale-[0.98] w-full sm:w-auto" data-id="element-164">
                QUIERO COMENZAR MI MÉTODO
              </button>

              <div className="flex items-center gap-2 text-brand-rose-light text-sm font-medium" data-id="element-165">
                <ShieldCheck className="w-4 h-4" data-id="element-166" />
                <span data-id="element-167">Garantía de Satisfacción de 30 Días</span>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}